function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withSnackbar } from 'notistack';
import { INotificationType } from 'swag-common/interfaces/snackbar-notification-type.interface';
import { HotProductsNotification } from './components/hot-products-notification';
import classes from './snackbar.scss';
let displayed = [];
const defaultOptions = {
  disableWindowBlurListener: true
};

// TODO: Rewrite it into hook after we start using such things as useDispatch, useSelector
const SnackbarManager = ({
  notifications,
  enqueueSnackbar,
  closeSnackbar,
  removeNotification
}) => {
  const storeDisplayed = id => {
    displayed = [...displayed, id];
  };
  const removeDisplayed = id => {
    displayed = [...displayed.filter(key => id !== key)];
  };
  useEffect(() => {
    notifications.forEach(({
      key,
      message,
      type = INotificationType.DEFAULT,
      isLimitedEdition,
      expirationDateLE,
      inStockLE,
      title = '',
      image = '',
      link = ''
    }) => {
      if (displayed.includes(key)) {
        removeNotification(key);
        return;
      }
      let options = _objectSpread({}, defaultOptions, {
        variant: type,
        action: [/*#__PURE__*/React.createElement(IconButton, {
          key: "close",
          "aria-label": "close",
          color: "inherit",
          className: classes.close,
          onClick: () => closeSnackbar(key)
        }, /*#__PURE__*/React.createElement(CloseIcon, null))]
      });
      if (type === INotificationType.HOT_PRODUCTS) {
        options = _objectSpread({}, defaultOptions, {
          autoHideDuration: 12000,
          content(key, message) {
            return /*#__PURE__*/React.createElement(HotProductsNotification, {
              isLimitedEdition: isLimitedEdition,
              expirationDateLE: expirationDateLE,
              inStockLE: inStockLE,
              typeName: title,
              productImage: image,
              productName: message,
              productLink: link,
              onClose: () => closeSnackbar(key)
            });
          }
        });
      }
      const parsedMsg = message !== null && message !== void 0 && message.includes('\n') ? message.split('\n').map((item, i, arr) => i + 1 < arr.length ? [item, /*#__PURE__*/React.createElement("br", null)] : item).flat() : message;
      enqueueSnackbar(parsedMsg, _objectSpread({
        key
      }, options, {
        onExited: (event, key) => {
          removeNotification(key);
          removeDisplayed(key);
        }
      }));
      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, removeNotification]);
  return null;
};
export const Snackbar = withSnackbar(SnackbarManager);